<template>
  <div>
    <b-container class="py-5 bg-white" fluid>
      <b-container>
        <b-row>
          <b-col md="12"><h1>Palomääräykset</h1></b-col>
        </b-row>
        <b-row>
          <b-col md="5"></b-col>
          <b-col :class="p1data !== null ? 'label':'label-disabled'">P1</b-col>
          <b-col :class="p2data !== null ? 'label':'label-disabled'">P2</b-col>
          <b-col :class="p3data !== null ? 'label':'label-disabled'">P3</b-col>
        </b-row>
        <b-row v-for="(item, index) in labels" :key="index" :class="'result-row rownum-'+index">
          <b-col md="5" class="label-col text-left">
            <span v-if="!item.isHeader" v-html="item.label"></span>
            <span v-else><h4 v-html="item.label"></h4></span>
          </b-col>
          <b-col class="data-col data-col-first">
            <span v-if="!item.isHeader && p1data !== null" v-html="p1data[index].value"></span>
          </b-col>
          <b-col class="data-col">
            <span v-if="!item.isHeader && p2data !== null" v-html="p2data[index].value"></span>
          </b-col>
          <b-col class="data-col">
            <span v-if="!item.isHeader && p3data !== null" v-html="p3data[index].value"></span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="viitteet" />
            <h4>Viitteet</h4>
            <ol>
              <li>Vain yläpuolista paloa vastaan, kun alapohjan ontelossa ei ole palovaaraa.</li>
              <li>Vaatimukset eivät koske pinta-alaltaan vähäisiä rakenneosia, kuten tavanomaisia ovia, ikkunoita, kiinnityspintoja, käsijohteita, listoja, saumalautoja ja levyjen saumoja.</li>
              <li>Vaatimukset eivät koske enintään 2-kerroksisen rakennuksen palkkeja ja pilareita, jotka täyttävät vaatimukset R 30 ja D-s2, d2.</li>
              <li>Vähäisiä osia pinnoista voidaan verhota tarvikkeilla, jotka eivät täytä vaatimusta.</li>
              <li>Vähäisiä osia seinäpinnoista voidaan verhota D-s2, d2-luokan tarvikkeilla. Koskee myös suojaverhouttuja seiniä.</li>
              <li>Ei vaatimusta, kun:
                <ul>
                  <li>lämmöneriste suojattu sisäpuolelta ja aukkojen pielien osalta EI 30 rakennusosalla</li>
                  <li>lämmöneriste suojattu ulkopuolelta EI 15 rakennusosalla tai tuuletusvälin sisäpinnassa on K<sub>2</sub> 10, A2-s1, d0 suojaverhous</li>
                </ul>
              </li>
              <li>Ei vaatimusta, kun:
                <ul>
                  <li>lämmöneriste suojattu sisäpuolelta ja aukkojen pielien osalta EI 30 rakennusosalla</li>
                  <li>lämmöneriste suojattu ulkopuolelta EI 30 rakennusosalla tai tuuletusvälin sisäpinnassa on K<sub>2</sub> 30, A2-s1, d0 suojaverhous</li>
                </ul>
              </li>
              <li>Ei vaatimusta, kun lämmöneriste suojattu sisäpuolelta ja aukkojen pielien osalta EI 60 rakennusosalla, kuitenkin seuraavissa tapauksissa EI 30 rakennusosalla:
                <ul>
                  <li>1…2-kerroksisessa ullakottomassa rakennuksessa</li>
                  <li>yläpohjan lämmöneriste on eristävältä osaltaan vähintään D-s2, d2-luokkaa</li>
                </ul>
              </li>
              <li>Tuuletusvälin paksuus enintään 50 mm ja koolausjako vähintään 600 mm (ristiinkoolaus mahdollinen).</li>
              <template v-if="userSelection.autosuojaosana == 'Kyllä'">
                <li>Palo-osaston enimmäisalaa voidaan kasvattaa enintään 50 %, jos palo-osaston ulkoseinistä vähintään 30 % on ulkotilaan pysyvästi avointa ja savunpoiston kannalta tarkoituksenmukaisesti sijoitettua aukotusta (avoin autosuoja).</li>
                <li>Palo-osaston enimmäisalaa voidaan kasvattaa enintään 50 %, jos tila varustetaan hätäkeskukseen kytketyllä paloilmoittimella ja tehokas sammutustyö voidaan aloittaa riittävän aikaisessa vaiheessa.</li>
              </template>

            </ol>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-a" />
            <b-card header="Ehdot A:  D-s2, d2-luokan ulkoverhous">
              <b-card-text>
              <ul>
                <li>Ensimmäisen kerroksen pintojen luokka B-s2, d0</li>
                <li>Uloskäytävien aukkojen ylä- ja alapuolen pintojen luokka B-s2, d0</li>
                <li>Varateinä toimivien ikkunoiden ja aukkojen ylä- ja alapuolen pintojen luokka B-s2, d0</li>
                <li>Palokatkot kerroksittain ulkoverhouksen tuuletusvälissä</li>
                <li>Palokatkot tuuletusvälissä estämään palon leviäminen vaakasuunnassa porrashuoneen ulkoverhouksen tuuletusväliin</li>
                <li>Paloräystäs EI 30</li>
                <li>Ulkoverhouksen laajojen osien putoaminen palotilanteessa rajoitettu</li>
              </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-b" />
            <b-card header="Ehdot B:  D-s2, d2-luokan ulkoverhous">
              <b-card-text>
                <ul>
                  <li>Palokatkot kerroksittain ulkoverhouksen tuuletusvälissä</li>
                  <li>Palokatkot tuuletusvälissä estämään palon leviäminen vaakasuunnassa porrashuoneen ulkoverhouksen tuuletusväliin</li>
                  <li>Paloräystäs EI 30</li>
                  <li>Ulkoverhouksen laajojen osien putoaminen palotilanteessa rajoitettu</li>
                  <li>Ulkoseinän lämmöneristeet ovat vähintään B-s1, d0-luokkaa tai ne on suojattu (<a href="#viitteet">ks. viite 6</a>)</li>
                  <li>Ulkoseinä ikkunoineen ja muine aukkoineen E 30 tai ulkoseinään rajoittuva palo-osasto sprinklattu tai varustettu hätäkeskukseen kytketyllä palo-ilmoittimella</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-c" />
            <b-card header="Ehdot C:  D-s2, d2-luokan ulkoverhous">
              <b-card-text>
                <ul>
                  <li>Ensimmäisen kerroksen pintojen luokka B-s2, d0</li>
                  <li>Uloskäytävien aukkojen ylä- ja alapuolen pintojen luokka B-s2, d0</li>
                  <li>Varateinä toimivien ikkunoiden ja aukkojen ylä- ja alapuolen pintojen luokka B-s2, d0</li>
                  <li>Palokatkot kerroksittain ulkoverhouksen tuuletusvälissä</li>
                  <li>Palokatkot tuuletusvälissä estämään palon leviäminen vaakasuunnassa porrashuoneen ulkoverhouksen tuuletusväliin</li>
                  <li>Paloräystäs EI 30</li>
                  <li>Ulkoseinän lämmöneristeet ovat vähintään B-s1, d0-luokkaa tai ne on suojattu (<a href="#viitteet">ks. viite 7</a>)</li>
                  <li>Edellisten lisäksi 14…28 m korkeassa rakennuksessa vaatimuksina sprinklaus sekä ulkoverhouksen laajojen osien putoaminen palotilanteessa rajoitettu</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-d" />
            <b-card header="Ehdot D:  D-s2, d2-luokan ulkoverhous">
              <b-card-text>
                <ul>
                  <li>Rakennuksessa on sprinklaus</li>
                  <li>Palokatkot kerroksittain ulkoverhouksen tuuletusvälissä</li>
                  <li>Palokatkot tuuletusvälissä estämään palon leviäminen vaakasuunnassa porrashuoneen ulkoverhouksen tuuletusväliin</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-e" />
            <b-card header="Ehdot E: Suojaverhouksen lievennykset enintään 2-kerroksisessa P2-paloluokan rakennuksessa">
              <b-card-text>
                <p><strong>Suojaverhousta ei vaadita:</strong></p>
                <ul>
                  <li>jos rakennusosassa käytetyt lämmöneristeet eristävältä osaltaan vähintään B-s1, d0 ja muut tarvikkeet vähintään D-s2, d2 (koskee kaikkia käyttötarkoituksia)</li>
                  <li>jos seinän sisäpinta vähintään B-s1, d0 ja seinä rakennusosana vähintään EI 15 (koskee muita käyttötarkoituksia paitsi asuntoa, majoitustilaa, hoitolaitosta)</li>
                  <li>jos lämmöneristeet eristävältä osaltaan vähintään D-s2, d2  ja muut tarvikkeet vähintään D-s2, d2 (koskee vain asuntoa)</li>
                  <li>D-s2, d2-luokan massiivipuuseinässä, jonka tiheys on vähintään 350 kg/m<sup>3</sup> (koskee kaikki käyttötarkoituksia)</li>
                  <li>pilareissa ja palkeissa, jotka täyttävät vaatimukset R 30 ja D-s2, d2 (koskee kaikki käyttötarkoituksia)</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="viitteet pt-3">
            <a name="ehdot-f" />
            <b-card header="Ehdot F: Suojaverhouksen lievennykset yli 2-kerroksisessa P2-paloluokan rakennuksessa">
              <b-card-text>
                <p> K<sub>2</sub> 30, A2-s1, d0-luokan suojaverhous mahdollistaa palo-osastossa suojaverhoamatonta seinä- ja kattopintaa seuraavasti:</p>
                <ul>
                  <li>ei kantavat väliseinät</li>
                  <li>≤ 20 %, kun palo-osaston rakennusosat R 60 ja EI 60</li>
                  <li>> 20 % ≤ 80 %, kun palo-osaston rakennusosat R 90 ja EI 90</li>
                  <li>> 80 %, kun palo-osaston rakennusosat R 120 ja EI 120</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="showEhdotG">
          <b-col class="viitteet pt-3">
            <a name="ehdot-g" />
            <b-card header="Ehdot G: Myymälätilan palo-osastokoko">
              <b-card-text>
                <p> Seuraavilla ehdoilla P2-paloluokan yli 2-kerroksisessa rakennuksessa saa olla myymälätila, jonka palo-osastokoko on >300 m2 - 1200 m2</p>
                <ul>
                  <li>myymälätila saa sijaita vain rakennuksen ensimmäisessä kerroksessa</li>
                  <li>myymälätilan kantavien rakennusosien tulee täyttää luokkavaatimukset R 90, A2-s1, d0</li>
                  <li>myymälätilan osastoivien rakennusosien tulee täyttää luokkavaatimukset EI 60, A2-s1, d0</li>
                </ul>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

      </b-container>
    </b-container>
  </div>
</template>

<script>
import filterTable from '../data/palomaaraykset.js'

export default {
  name: 'Maaraykset',
  data () {
    return {
    }
  },
  computed: {
    labels: function () {
      return filterTable('', this.userSelection)
    },
    p1data: function () {
      return (this.userSelection.results.p1 && this.userSelection.results.p1.passed) ? filterTable('P1', this.userSelection) : null
    },
    p2data: function () {
      return (this.userSelection.results.p2 && this.userSelection.results.p2.passed) ? filterTable('P2', this.userSelection) : null
    },
    p3data: function () {
      return (this.userSelection.results.p3 && this.userSelection.results.p3.passed) ? filterTable('P3', this.userSelection) : null
    },
    showEhdotG: function () {
      if (this.userSelection.kayttotarkoitus === 3 || this.userSelection.myymalaosana === 'Kyllä') {
        return true
      }
      return false
    }
  },
  methods: {
    updatePintaluokat () {
      if (this.p1data) {
        this.userSelection.results.p1.pintaluokat = {
          seinapinta: this.p1data[33].value, // Seinä- ja kattopinnat kerroksessa
          kattopinta: this.p1data[33].value,
          lattiapinta: this.p1data[38].value, // Lattiapinnat kerroksessa
          tspinta: this.p1data[52].value,
          tupinta: this.p1data[50].value,
          uupinta: this.p1data[49].value
        }
      }
      if (this.p2data) {
        this.userSelection.results.p2.pintaluokat = {
          seinapinta: this.p2data[33].value,
          kattopinta: this.p2data[33].value,
          lattiapinta: this.p2data[38].value,
          tspinta: this.p2data[52].value,
          tupinta: this.p2data[50].value,
          uupinta: this.p2data[49].value
        }
      }
      if (this.p3data) {
        this.userSelection.results.p3.pintaluokat = {
          seinapinta: this.p3data[33].value,
          kattopinta: this.p3data[33].value,
          lattiapinta: this.p2data[38].value,
          tspinta: this.p3data[52].value,
          tupinta: this.p3data[50].value,
          uupinta: this.p3data[49].value
        }
      }
    }
  }
}
</script>

<style scoped>
  .result-row{
    font-size: 0.85em;
    border-left: 1px solid #dee2e6;
  }
  .rownum-0{
    border-radius: 4px 4px 0 0;
    border-top: 1px solid #dee2e6;
  }
  .result-row:last-of-type{
    border-radius: 0 0 4px 4px;
    border-bottom: 1px solid #dee2e6;
  }

  .label-col{
    padding: 1em;
  }
  .data-col-first{
    border-left: 1px solid #dee2e6;
  }
  .data-col{
    padding: 1em;
    border-right: 1px solid #dee2e6;
  }
  .card-header{
    font-weight: bold;
  }

  .result-row:nth-child(odd){
    background-color: #FAFAFA;

  }
  .label{
    font-weight: bold;
  }
  .label-disabled{
    opacity: 0.5;
  }

  .viitteet{
    text-align: left;
    font-size: 0.9em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Maaraykset.vue